import React, { Component } from 'react';

class Skills extends Component {
  
  render() {
    const skills = (
    <section id="skills-tools" className="resume-section">
	<article className="container">
	  <div className="row">
		<div className="category-title col-md-12">
		  <div className="row">
			<div className="col-md-4">
			  <h2>Skills &amp; Tools</h2>
			</div>
		  </div>
		</div>
		<div className="card-container">
		  <span className="col-md-3 col-md-offset-1 side-note hidden-print">Programming Languages</span>
		  <div className="col-md-6 resume-card">
			<h3 className="title">Programming Languages</h3>
			<div className="skill">
			  <h4 className="title">.Net C#</h4>
			  <div className="progress">
				<div className="progress-bar" role="progressbar" aria-valuenow="90" aria-valuemin="0" aria-valuemax="90" style={{width: 90+'%'}}>
				  <span className="sr-only">Professional</span>
				</div>
			  </div>
			</div>
			<div className="skill">
			  <h4 className="title">Php</h4>
			  <div className="progress">
				<div className="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="70" style={{width: 70+'%'}}>
				  <span className="sr-only">Professional</span>
				</div>
			  </div>
			</div>
			<div className="skill">
			  <h4 className="title">JavaScript</h4>
			  <div className="progress">
				<div className="progress-bar" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="80" style={{width: 80+'%'}}>
				  <span className="sr-only">Intermediate</span>
				</div>
			  </div>
			</div>
			<div className="skill">
			  <h4 className="title">Java</h4>
			  <div className="progress">
				<div className="progress-bar" role="progressbar" aria-valuenow="50" aria-valuemin="0" aria-valuemax="50" style={{width: 50+'%'}}>
				  <span className="sr-only">Intermediate</span>
				</div>
			  </div>
			</div>
			<div className="skill">
			  <h4 className="title">Sql</h4>
			  <div className="progress">
				<div className="progress-bar" role="progressbar" aria-valuenow="85" aria-valuemin="0" aria-valuemax="85" style={{width: 85+'%'}}>
				  <span className="sr-only">Professional</span>
				</div>
			  </div>
			</div>
			<h3 className="title"><small>Other Languages &amp;  Frameworks</small></h3>
			<p>C<br/> C++<br/>Shell &amp; batch scripting<br/>
			NodeJs</p>
		  </div>
		</div>
		<div className="card-container">
		  <span className="col-md-3 col-md-offset-1 side-note hidden-print">Front-end Development</span>
		  <div className="col-md-6 resume-card">
			<h3 className="title">Front-end Development</h3>
			<div className="skill">
			  <h4 className="title">HTML &amp; CSS</h4>
			  <div className="progress">
				<div className="progress-bar" role="progressbar" aria-valuenow="85" aria-valuemin="0" aria-valuemax="100" style={{width: 85+'%'}}>
				  <span className="sr-only">Intermediate</span>
				</div>
			  </div>
			</div>
			<div className="skill">
			  <h4 className="title">Angular</h4>
			  <div className="progress">
				<div className="progress-bar" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style={{width: 60+'%'}}>
				  <span className="sr-only">Intermediate</span>
				</div>
			  </div>
			</div>
			<div className="skill">
			  <h4 className="title">ReactJs</h4>
			  <div className="progress">
				<div className="progress-bar" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style={{width: 60+'%'}}>
				  <span className="sr-only">Intermediate</span>
				</div>
			  </div>
			</div>
		  </div>
		</div>
		<div className="card-container">
		  <span className="col-md-3 col-md-offset-1 side-note">Toolset</span>
		  <div className="col-md-6 resume-card">
			<h3 className="title">My prefered tools<small>FROM DESIGN TO CODE</small></h3>
			<div className="row list">
			  <div className="col-md-5">
				<ul className="list-unstyled">
				  <li>Visual Studio</li>
				  <li>Visual Studio Code</li>
				  <li>Vim</li>
				</ul>
			  </div>
			  <div className="col-md-5">
				<ul className="list-unstyled">
				  <li>Photoshop</li>
				  <li>Github</li>
				  <li>Team Foundation Server</li>
				  <li>Slack</li>
				</ul>
			  </div>
			</div>
		  </div>
		</div>
	  </div>
	</article>
  </section>
     
    );
    return (
         skills
    );
  }
  
}

export default Skills;



// WEBPACK FOOTER //
// ./src/components/resume-components/skills.js